module.exports = __webpack_public_path__ + "static/column-8d9e26fb018c0febeaa4d111c473a8f9.jpg";